// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__128My","buttons":"styles_buttons__1FCKW"};